import { Button } from "components/Button/Button";
import { IconCollection } from "components/Icon/IconCollection";
import { TableColumn } from "components/Table/tableUtils";
import { actions as executionsActions } from "containers/Executions/Executions.reducer";
import { Execution_Dump } from "graphql/generated/graphql";
import { useDispatch } from "react-redux";
import { createdAtDto } from "./utils";
const LoadSavepointAction = (resourceData) => {
    const dispatch = useDispatch();

    const executionId = resourceData.executionId;
    if (!executionId) return <div>Not loadable</div>;

    const onClick = () => {
        new Promise((resolve, reject) => {
            dispatch({
                type: executionsActions.START_CREATE_EXECUTION_OPERATION,
                promise: { resolve, reject },
                variables: {
                    execution_id: resourceData?.executionId,
                    operation: {
                        op: "load_savepoint",
                        by: "id",
                        id: resourceData?.id,
                    },
                },
            });
        })
            .then(() => {})
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {});
    };

    return (
        <Button
            onClick={onClick}
            icon={IconCollection.cubeSend}
            size={"small"}
            variation={"dark"}
            title={"Load"}
        />
    );
};

const getActionStr = (data?: Execution_Dump) => {
    return data?.action?.toLowerCase() || "";
};

export const columns: Array<TableColumn> = [
    {
        label: "Created at",
        key: "created_at",
        dto: createdAtDto,
        shown: true,
        filterable: false,
    },
    {
        label: "Line number",
        key: "lineno",
        dto: (data) => {
            const line = data?.lineno;
            return <div className="type-cell">{line}</div>;
        },
        shown: true,
    },
    {
        label: "Command",
        key: "last_command",
        dto: (data) => {
            const line = data?.last_command;
            return <div className="type-cell">{line}</div>;
        },
        shown: true,
    },
    {
        label: "Action",
        key: "action",
        dto: (data?: Execution_Dump) => {
            return <div className="type-cell">{getActionStr(data)}</div>;
        },
        shown: true,
        sortable: true,
    },
    {
        label: "Load",
        key: "load_savepoint",
        dto: (data?: Execution_Dump) => {
            const action = getActionStr(data);
            const isExit = action === "exit";
            if (isExit) {
                return null;
            }
            return LoadSavepointAction(data);
        },
        shown: true,
        sortable: false,
        filterable: false,
    },
];
